import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Users } from "./../models/users";

@Injectable()
export class AuthenticationService {
  readonly apiUrl = "api";
  readonly currentUser = "currentUser";
  readonly currentToken = "currentToken";
  readonly DUREESESSION = (10 * 60 * 1000);

  constructor(private http: Http) {}

  login(username: string, password: string): Observable<boolean> {
    console.log(`login with ${username}" password "`);
    const options = new RequestOptions({
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      })
    });
    const body = new URLSearchParams();
    body.set("username", username);
    body.set("password", password);
    return this.http
      .post(`${this.apiUrl}/users/login`, body.toString(), options)
      .map((resp: Response) => {
        console.log("resp", resp);

        const user = resp.json();
        if (user) {
          console.log(`authentificated user is ${user}`);
          sessionStorage.setItem(this.currentUser, JSON.stringify(user));
          sessionStorage.setItem(
            this.currentToken, JSON.stringify({ 'token': "Basic " + btoa(username + ":" + password), expireAt: new Date().setTime(new Date().getTime() + this.DUREESESSION )})
          );
          return true;
        }
        return false;
      });
  }

  getToken(): string {
    const token = JSON.parse(sessionStorage.getItem(this.currentToken));
    if (token) {
      const expireDate: number = new Date().setTime(token.expireAt);
      if (expireDate >= new Date().getTime()) { // si la session nest expirer alors reset la duree d'expiration
        sessionStorage.setItem(this.currentToken, JSON.stringify({ 'token': token.token, expireAt: new Date().setTime(new Date().getTime() + this.DUREESESSION )}));
        return token.token;
      }
    }
    return null ;
  }
  getUser(): Users {
    return JSON.parse(sessionStorage.getItem(this.currentUser));
  }
  getConnectedUser(): Observable<Users> {
    return Observable.of(this.getUser());
  }

  logout(): void {
    sessionStorage.removeItem(this.currentUser);
    sessionStorage.removeItem(this.currentToken);
    console.log("user logout");
  }

  isLoggedIn(): boolean {
    const token = this.getToken();
    console.log(`isloggedIn token ${token}`);
    return token && token.length > 0;
  }

  hasRole(role: string, user?: Users): boolean {
    if (!user) {
      user = this.getUser();
    }
    if (!user.isActive) {
      return false;
    }
    if (user.isSuperAdmin) {
      return true;
    }
    if (user.permissions === undefined) {
      return false;
    }
    if (role === "dashboard") {
      return true;
    }

    return user.permissions.filter(p => p === role).length > 0;
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/authentication.service.ts